function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group 1"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle 2",
  width: 97,
  height: 101,
  rx: 4,
  transform: "matrix(1 0 -0.180862 0.983508 56.2671 0)",
  fill: "#FFFFFF"
}), /*#__PURE__*/React.createElement("g", {
  id: "Mask Group"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask0",
  "mask-type": "alpha",
  maskUnits: "userSpaceOnUse",
  x: 52,
  y: 9,
  width: 89,
  height: 70
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle 1",
  width: 77,
  height: 70,
  rx: 4,
  transform: "matrix(1 0 -0.180862 0.983508 64.4585 9.83508)",
  fill: "#E2E2E2"
})), /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle 3",
  width: 96,
  height: 96,
  rx: 4,
  transform: "matrix(1 0 -0.180862 0.983508 58.2671 0)",
  fill: "#E9E9E9"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector 1",
  d: "M81.9632 18.6867C74.6935 18.6867 62.1636 33.3467 59.0007 37.1937C58.5071 37.794 58.1902 38.4832 58.0599 39.192L50.6172 79.6642C50.2177 81.8369 51.6847 83.5982 53.8938 83.5982H125.894C128.103 83.5982 130.218 81.8369 130.617 79.6642L135.082 55.3834C135.179 54.8563 135.17 54.3416 135.041 53.8599C134.118 50.4191 129.914 35.8981 124.666 35.8981C118.712 35.8981 113.473 47.8202 106.804 47.8202C100.135 47.8202 90.3307 18.6867 81.9632 18.6867Z",
  fill: "#D2D2D2"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse 1",
  r: 5,
  transform: "matrix(1 0 -0.180862 0.983508 107.565 25.5712)",
  fill: "#D2D2D2"
})))), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle 8",
  x: 30,
  y: 82,
  width: 17,
  height: 6,
  rx: 3,
  fill: "#FFFFFF"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle 9",
  x: 8,
  y: 82,
  width: 17,
  height: 6,
  rx: 3,
  fill: "#FFFFFF"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle 7",
  x: 12,
  y: 71,
  width: 35,
  height: 6,
  rx: 3,
  fill: "#FFFFFF"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle 6",
  x: 18,
  y: 60,
  width: 29,
  height: 6,
  rx: 3,
  fill: "#FFFFFF"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle 10",
  x: 2,
  y: 60,
  width: 11,
  height: 6,
  rx: 3,
  fill: "#FFFFFF"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle 5",
  y: 93,
  width: 47,
  height: 6,
  rx: 3,
  fill: "#FFFFFF"
}), /*#__PURE__*/React.createElement("ellipse", {
  id: "Ellipse 2",
  cx: 89.5,
  cy: 117,
  rx: 51.5,
  ry: 5,
  fill: "#C4C4C4"
}));

var SvgNoImage = function SvgNoImage(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 154,
    height: 122,
    viewBox: "0 0 154 122",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNoImage, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/no_image.49329719.svg";
export { ForwardRef as ReactComponent };